// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"a08b0cae","354":"3c3ce9de","418":"82247b05"}[chunkId] + ".js";
};